//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import OddsTable from '../components/OddsTable'

export default {
    name: 'FirstGoalLastGoal',
    components: {
        OddsTable
    }
}
